<sh-loading *ngIf="loading$ | async else content" [message]="'ui.loading'| translate"></sh-loading>
<ng-template #content>
    <ng-content></ng-content>
</ng-template>
